export const GET_COURIER_STATISTICS = Symbol('GET_COURIER_STATISTICS');
export const GET_COURIER_STATISTICS_REQUEST = Symbol('GET_COURIER_STATISTICS_REQUEST');
export const GET_COURIER_STATISTICS_SUCCESS = Symbol('GET_COURIER_STATISTICS_SUCCESS');
export const GET_COURIER_STATISTICS_ERROR = Symbol('GET_COURIER_STATISTICS_ERROR');



